import {http, onSuccess, onFail} from "./http";

// Members groups
// Get(path="/event/episode/{episode}/group") - LIST
export const episodeGroupsList = (episodeId) => {
    return http.get(`/api/cp/event/episode/${episodeId}/group`)
        .then(onSuccess, onFail);
};

// Post(path="/event/episode/{episode}/group") - ADD (POST:role=roleId)
export const episodeCreateGroup = (episodeId, payload) => {
    return http.post(`/api/cp/event/episode/${episodeId}/group`, payload)
        .then(onSuccess, onFail);
};

// Post(path="/event/episode/group/{group}") - UPDATE
export const episodeUpdateGroup = (groupId, payload) => {
    return http.post(`/api/cp/event/episode/group/${groupId}`, payload)
        .then(onSuccess, onFail);
};

// Delete(path="/event/episode/group/{group}") - DELETE
export const episodeDeleteGroup = (groupId) => {
    return http.delete(`/api/cp/event/episode/group/${groupId}`)
        .then(onSuccess, onFail);
};

// Post(path="/event/episode/{episode}/groups-order") - ORDER
export const episodeOrderGroup = (episodeId, payload) => {
    return http.post(`/api/cp/event/episode/${episodeId}/groups-order`, payload)
        .then(onSuccess, onFail);
};

// Episode members groups
// Get(path="/event/episode/{episode}/members") - LIST all in episode
export const episodeMembersList = (episodeId) => {
    return http.get(`/api/cp/event/episode/${episodeId}/members`)
        .then(onSuccess, onFail);
};

// Get(path="/event/episode/group/{group}/members") - LIST in group
export const episodeGroupMembersList = (groupId) => {
    return http.get(`/api/cp/event/episode/group/${groupId}/members`)
        .then(onSuccess, onFail);
};

// Post(path="/event/episode/{episode}/members") - ADD (POST:member={memberId}, group={groupId})
export const episodeGroupMemberAdd = (episodeId, payload) => {
    return http.post(`/api/cp/event/episode/${episodeId}/members`, payload)
        .then(onSuccess, onFail);
};

// Post(path="/event/episode/members/{episodeMember}") - UPDATE
export const episodeGroupMemberUpdate = (memberId, payload) => {
    return http.post(`/api/cp/event/episode/members/${memberId}`, payload)
        .then(onSuccess, onFail);
};

// Delete(path="/event/episode/members/{episodeMember}") - DELETE
export const episodeGroupMemberDelete = (memberId) => {
    return http.delete(`/api/cp/event/episode/members/${memberId}`)
        .then(onSuccess, onFail);
};

// Post(path="/event/episode/{episode}/members-order") - ORDER
export const episodeGroupMembersOrder = (episodeId, payload) => {
    return http.post(`/api/cp/event/episode/${episodeId}/members-order`, payload)
        .then(onSuccess, onFail);
};

// Post(path="/event/episode/{episode}/groups-order") - ORDER
export const episodeGroupsOrder = (episodeId, payload) => {
    return http.post(`/api/cp/event/episode/${episodeId}/groups-order`, payload)
        .then(onSuccess, onFail);
};
